import { useContext, useEffect, useState } from "react";
import Table from "src/components/Table";
import { PiEyeDuotone } from "react-icons/pi";
import { FiEdit } from "react-icons/fi";
import { get, post } from "src/services/HttpClient";
import PermissionBasedComponent from "src/components/PermissionBasedComponent";
import userContext from "src/context/userContext";
import DeleteModal from "src/components/DeleteModal";
import { useNavigate } from "react-router-dom";
import { IoTrashOutline } from "react-icons/io5";
import { LuLogIn } from "react-icons/lu";
import { notify } from "src/services/Notification/Notification";
import axios from "axios";

export default function UserTable() {
    const navigate = useNavigate();

    const { setUser } = useContext(userContext)
    const [data, setData] = useState()
    const [active, setActive] = useState(false)
    const [reload, setReload] = useState(false)
    const [selectedRow, setSelectedRow] = useState()

    const getUser = async () => {
        const result = await get("/user");
        if (result) {
            setUser(result.body);
        }
    };

    const getUsers = async () => {
        const result = await get("/users/all");
        setData(result.data)
    }
    useEffect(() => {
        getUsers();
    }, [reload])

    const columns = [
        {
            id: "id",
            cell: (info) => info.getValue(),
            header: "شناسه",
        },
        {
            id: "firstName",
            cell: (info) => info.getValue(),
            header: <span>نام</span>,
        },
        {
            id: "lastName",
            cell: (info) => info.getValue(),
            header: <span>نام خانوادگی</span>,
        },
        {
            id: "email",
            cell: (info) => info.getValue(),
            header: "ایمیل",
        },
        {
            id: "role",
            cell: (info) => info.getValue() ? info.row.original.role.description : "---",
            header: "نقش کاربری",
        },
        {
            id: "id",
            cell: (info) => (
                <div className="flex gap-2">
                    <PermissionBasedComponent permission="loginAsUser">
                        <div
                            className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 dark:bg-gray-700 bg-gray-50 text-gray-400 p-2 rounded-lg"
                            onClick={async () => {
                                const result = await post("/login-as-user", {
                                    email: info.row.original.email,
                                });
                                if (result) {
                                    let superUserToken = localStorage.getItem("access_token");
                                    localStorage.setItem("super_access_token", superUserToken);
                                    localStorage.setItem("access_token", result.body.token);
                                    axios.defaults.headers.common['Authorization'] = result.body.token;
                                    getUser();
                                    navigate("/");
                                } else {
                                    notify("خطایی رخ داده است", "error")
                                }
                            }}
                            title="login as user"
                        >
                            <LuLogIn className="text-green-500" />
                        </div>
                    </PermissionBasedComponent>
                    <PermissionBasedComponent permission="editUser">
                        <div
                            className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 dark:bg-gray-700 bg-gray-50 text-gray-400 p-2 rounded-lg"
                            onClick={() => {
                                navigate(
                                    `/app/setting/user-management/user/edit?id=${info.getValue()}`
                                );
                            }}
                        >
                            <FiEdit className="text-blue-500" />
                        </div>
                    </PermissionBasedComponent>
                    <PermissionBasedComponent permission="deleteUser">
                        <div
                            className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 dark:bg-gray-700 bg-gray-50 text-gray-400 p-2 rounded-lg"
                            onClick={() => {
                                setSelectedRow(info.getValue())
                                setActive(true)
                            }}
                        >
                            <IoTrashOutline className="text-red-500" />
                        </div>
                    </PermissionBasedComponent>
                </div>
            ),
            header: "عملیات",
            footer: (info) => info.column.id,
            enableColumnFilter: false,
        },
    ];


    return (
        <>
            <Table data={data} columns={columns} CSVExportPermission="exportUsers" />
            <DeleteModal
                title="حذف کاربر"
                id={selectedRow}
                url="/users"
                active={active}
                setActive={setActive}
                additionalAction={() => { setReload(!reload) }}
            />
        </>
    );
}   
